var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: {
        show: _vm.show,
        "max-width": _vm.maxWidth,
        closeable: _vm.closeable,
      },
      on: { close: _vm.close },
    },
    [
      _c("div", { staticClass: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }, [
        _c("div", { staticClass: "sm:flex sm:items-start" }, [
          _c(
            "div",
            {
              staticClass:
                "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10",
            },
            [
              _c(
                "svg",
                {
                  staticClass: "h-6 w-6 text-red-600",
                  attrs: {
                    stroke: "currentColor",
                    fill: "none",
                    viewBox: "0 0 24 24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" },
            [
              _c("h3", { staticClass: "text-lg" }, [_vm._t("title")], 2),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2" }, [_vm._t("content")], 2),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "px-6 py-4 bg-gray-100 text-right" },
        [_vm._t("footer")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }